/* 🤖 this file was generated by svg-to-ts*/
export const icoInfoDuo: {
  name: 'info-duo';
  data: string;
} = {
  name: 'info-duo',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path opacity="0.12" d="M12.5 21C17.47 21 21.5 16.97 21.5 12C21.5 7.03 17.47 3 12.5 3C7.53 3 3.5 7.03 3.5 12C3.5 16.97 7.53 21 12.5 21Z" fill="#858585"/>
  <path d="M12.5 22C6.99 22 2.5 17.51 2.5 12C2.5 6.49 6.99 2 12.5 2C18.01 2 22.5 6.49 22.5 12C22.5 17.51 18.01 22 12.5 22ZM12.5 4C8.09 4 4.5 7.59 4.5 12C4.5 16.41 8.09 20 12.5 20C16.91 20 20.5 16.41 20.5 12C20.5 7.59 16.91 4 12.5 4ZM12.5 17C11.95 17 11.5 16.55 11.5 16V12C11.5 11.45 11.95 11 12.5 11C13.05 11 13.5 11.45 13.5 12V16C13.5 16.55 13.05 17 12.5 17ZM12.5 9C11.95 9 11.5 8.55 11.5 8C11.5 7.45 11.94 7 12.5 7C13.05 7 13.5 7.45 13.5 8C13.5 8.55 13.05 9 12.5 9Z" fill="#858585"/>
  </svg>`
};
